/*
 * Edit Job Modal and Redux Connector
 */

import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import queryString from 'query-string';

import { IinitialState } from '../../reducers';
import { WithCommonModal } from '../common/WithCommonModal';

import { selectIsLoading } from '../../reducers/commonReducers';
import { SearchAllPartsForm } from '../manageJob/SearchAllPartsForm';
import { Ipart } from '../../models';
import { removeQuery } from '../common/OtherUtils';
import { suggestedPartsQueryParamsEnum } from './SuggestedParts';
import { partTypeEnum } from '../../models-enums';

interface Iprops {
    colorButton: string;
    disabled?: boolean;
    secondModal?: boolean;
    queryParams?: typeof suggestedPartsQueryParamsEnum;
    onSubmit: (part: Ipart) => void;
    shouldShowQuantity?: boolean;
    partType: partTypeEnum;
}

const mapStateToProps = (state: IinitialState, ownProps: Iprops & WithTranslation & RouteComponentProps) => {
    // Parse query params directly from location to ensure we react to URL changes
    const queryParams = queryString.parse(ownProps.location.search) as typeof suggestedPartsQueryParamsEnum;
    
    // define the closeModal function here in mapState so that we can pass it to both the main component and
    // to the onHide which is a WithCommonModal HOC prop
    // yes it is unusual to pass a function in mapState, but it is ok since it does not need dispatch
    const closeModal = () => {
        removeQuery(suggestedPartsQueryParamsEnum.showSearchPartsModal, ownProps.history);
    };

    const title = ownProps.t('nsPart:searchAllPartsModal.modalTitle');
    const showValue = !!queryParams.showSearchPartsModal;

    return {
        className: 'part-search',
        loading: selectIsLoading(state),
        title,
        online: state.offline.online,
        closeModal,
        onHide: closeModal,
        show: showValue
    };
};

export const SearchAllPartsModalandContainer = withRouter(
    withTranslation('nsPart')(
        connect(mapStateToProps, {})(WithCommonModal(SearchAllPartsForm))
    )
);
